<template>
  <div class="d-contents">
    <v-progress-circular v-if="loading" size="24" width="2" indeterminate />
    <div v-else class="file-link spacex-8" @click.stop="loadTemplate">
      <ExcelIcon :height="iconSize" />
      <div class="file-name">
        {{ fileName }}
      </div>
    </div>
  </div>
</template>

<script>
  import ExcelIcon from '@/assets/icons/excel.svg';
  import absoluteLink from '@/utils/formatting/absolute-link';
  import request from '@/utils/api/request';
  import { VProgressCircular } from 'vuetify/lib';

  export default {
    name: 'ExcelTemplate',
    components: {
      ExcelIcon,
      VProgressCircular,
    },
    props: {
      iconSize: {
        type: Number,
        default: 24,
      },
      text: {
        type: String,
        required: false,
      },
      incomingTenderId: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
      };
    },
    computed: {
      fileLink() {
        return `/incoming_tenders/offers/${this.incomingTenderId}/xlsx_template/`;
      },
      fileName() {
        return this.text || this.$t('Excel template');
      },
      link() {
        return absoluteLink(this.fileLink);
      },
    },
    methods: {
      async loadTemplate() {
        this.loading = true;
        try {
          const { data, headers } = await request.get(this.link, {
            responseType: 'blob',
          });

          const file = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });

          const contentDisposition = headers['content-disposition'];
          const filenamePart = contentDisposition.split(';')[1];

          var a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = URL.createObjectURL(file);
          a.download = filenamePart.split('=')[1].replaceAll('"', '');

          a.click();
          URL.revokeObjectURL(file);
        } catch (e) {
          console.error(e);
        }
        this.loading = false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  @import 'src/styles/colors';

  .excel-template {
    margin: 0 8px;
    display: inline-flex;
    vertical-align: middle;
  }

  .file-link {
    font-weight: 500;
    font-size: 14px;
    color: $primary600;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
    display: inline-flex;
    flex-direction: row;
    cursor: pointer;
  }

  .file-name {
    display: flex;
    align-items: center;
  }
</style>
